import getClientApiRequestTransformer from '@/api/transformers/auth.request.transformer';
import getSocketIdRequestTransformer from '@/api/transformers/socketId.request.transformer';
import clientApi from '@/apiClient';

export default {
  async clearAllNotices() {
    return clientApi.delete('/notification/delete-all', {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  }
};
